import { render, staticRenderFns } from "./ExamineMag.vue?vue&type=template&id=0c9b007d&scoped=true"
import script from "./ExamineMag.vue?vue&type=script&lang=js"
export * from "./ExamineMag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b007d",
  null
  
)

export default component.exports